import './self-pickups.module';
import './self-pickups.config';
import './$selfPickups.factory';

import './components';
import './constants';
import './filters';
import './services';
